
    import {Inject, Options, Vue} from 'vue-property-decorator';
    import TagsSelection from '@/profile-creation-wizard/components/for-creation/ui/3_expertise/skills/TagsSelection.vue';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import {CreationFormValidation} from '@/profile-creation-wizard/components/for-creation/ProfileCreationForm';
    import {ProfileCreationService} from '@/profile-creation-wizard/components/for-creation/ProfileCreationService';
    import {Getter} from 'vuex-class';
    import getters from '@/profile-creation-wizard/components/for-creation/store/getters';
    import type {ProfileCreationForm} from '@/profile-creation-wizard/components/for-creation/store';
    import StepActions from '@/profile-creation-wizard/common/ui/step/StepActions.vue';
    import StepMobileHeader from '@/profile-creation-wizard/common/ui/step/StepMobileHeader.vue';
    import {TrackingRepository} from '@/common/repositories/track/TrackingRepository';
    import {StepNavigator} from '@/profile-creation-wizard/common/step/StepNavigator';
    import MaltClassicExpertiseSide from '@/profile-creation-wizard/components/for-creation/ui/3_expertise/MaltClassicExpertiseSide.vue';

    @Options({
        components: {
            MaltClassicExpertiseSide,
            TagsSelection,
            StepActions,
            StepMobileHeader,
        },
    })
    export default class MaltClassicExpertiseStep extends Vue {
        @Inject({from: DI.creationFormValidation})
        creationFormValidation!: CreationFormValidation;
        @Inject({from: DI.profileCreationService})
        profileCreationService!: ProfileCreationService;
        @Inject({from: DI.trackingRepository})
        trackingRepository!: TrackingRepository;
        @Getter(getters.creationForm)
        creationForm!: ProfileCreationForm;
        progressPercentage = 0;

        stepName = 'expertise';

        mounted(): void {
            window.scrollTo({
                top: 0,
            });
        }

        created(): void {
            this.trackingRepository.track('expertise-view-page-v2');
            if (window.hj) {
                // Custom event Hotjar
                window.hj('event', 'profile_creation_details_page');
            }
            const meta = this.$router.currentRoute.value.meta;
            this.progressPercentage = meta.progressPercentage || 0;
            this.stepNavigator = new StepNavigator(this.$router, meta.previousStep, meta.nextStep);
        }

        get hasValidFieldPart(): boolean {
            const form = this.creationForm;

            return this.creationFormValidation.isTagsValid(form.tags);
        }

        goToPrevious(): void {
            this.stepNavigator.previous();
        }

        goNext(): void {
            this.trackingRepository.track('skills-chosen-v2', {
                skills: this.creationForm.tags.map((tag) => tag.name),
            });

            this.stepNavigator.next();
        }
    }
